// API DOC = https://swiperjs.com/swiper-api
import Swiper from 'swiper/bundle';
import {find} from '../helpers';

let flipSwiper;
const flipElement = find('[data-swipe-flip]');

// Define a media breakpoint for responsive behavior
const breakpoint = window.matchMedia('(min-width: 64em)');

// Function to create the flip Swiper instance
const createFlipSwiper = () => {

    // Check if flipSwiper already exists before creating a new instance
    if (!flipSwiper) {
        flipSwiper = new Swiper(flipElement, {
            loop: true,
            effect: 'flip',
            flipEffect: { slideShadows: false },
            autoplay: { delay: 3000 },
            speed: 500,
            centeredSlides: true,
            spaceBetween: 16,
        });
    }
};

// Function to destroy the flip Swiper instance
const destroyFlipSwiper = () => {
    if (flipSwiper) {
        flipSwiper.destroy();
        flipSwiper = undefined;
    }
};

// Function to handle the responsive behavior using the media breakpoint
const breakpointChecker = () => {
    if (breakpoint.matches) {
        // If the screen is wider than the breakpoint, destroy the flip Swiper
        destroyFlipSwiper();
    } else {
        // If the screen is narrower than the breakpoint, create the flip Swiper
        createFlipSwiper();
    }
};

if (flipElement) {
    // Add a listener to the media breakpoint and call the checker function initially
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
}
